<p-panel>
  <app-reactive-form-builder #formbuilder (formChanges)="formChanges($event[0], $event[1])" (goBack)="goBack()"
    [form]="form.formFields" [serverUrl]="''" [dropdownLoadTrigger]="dropdownLoadTrigger" [dropdownsFinalized]="dropdownsFinalized" [id]="getModel().id"
    [request]="this.getType() === 1 ? this.analisisApi.analisis.PUT : this.analisisApi.analisis.POST"
    [getRequest]="this.analisisApi.analisis.GET">
  </app-reactive-form-builder>
</p-panel>

<br>